import classnames from 'classnames';
import type { PropsWithChildren } from 'react';
import React from 'react';

import type { CameraModeEnum } from './types';
import { CameraModeUI } from './UI';

type CameraModeProps = {
  isActive: boolean;
  mode: CameraModeEnum;
  onChange: (mode: CameraModeEnum) => void;
} & PropsWithChildren;

const CameraMode: React.FC<CameraModeProps> = ({ mode, onChange, isActive: active, children }) => {
  const handleOnClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onChange(mode);
  };

  return (
    <CameraModeUI className={classnames({ active })} onClick={handleOnClick} data-cy={`camera-mode-${mode}`}>
      {children}
    </CameraModeUI>
  );
};

export default CameraMode;
